import styled, { keyframes } from "styled-components";
import { colors, font, radius, shadow } from "../../styles/theme/tokens";

const popIn = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
`;

const pulse = keyframes`
  0%, 100% { box-shadow: 0 0 0 0 rgba(244, 182, 63, 0.55); }
  50% { box-shadow: 0 0 0 8px rgba(244, 182, 63, 0); }
`;

// Під шторкою меню (99–100), щоб на телефоні не висіти поверх відкритого меню
export const Ring = styled.div`
  position: fixed;
  z-index: 90;
  border: 2px solid ${colors.amber};
  border-radius: ${radius.md};
  pointer-events: none;
  animation: ${pulse} 1.6s ease-in-out infinite;
`;

export const Bubble = styled.div`
  position: fixed;
  z-index: 90;
  padding: 14px 16px 12px;
  border-radius: ${radius.md};
  font-family: ${font.text};
  color: #FFFFFF;
  background: ${colors.brandDark};
  box-shadow: ${shadow.raised};
  animation: ${popIn} 0.25s ease-out;

  p {
    font-size: 14px;
    line-height: 1.45;
  }

  button {
    margin-top: 10px;
    padding: 6px 14px;
    border: none;
    border-radius: ${radius.pill};
    font-family: ${font.text};
    font-size: 13px;
    font-weight: 800;
    color: ${colors.brandDark};
    background: ${colors.amber};
    cursor: pointer;
  }
`;
